import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import validate from './validation'
import * as ContentActions from '../../../../actions/content'
import { notify as notifyAction } from '../../../../actions/notifications'
import { PlaylistsFormExtra } from '../../../../components/Screens'
import { playlistsForm as playlistsFormProps } from '../../../../types'
import { ObjectUtils } from '../../../../utils'

// Default start date
const defaultStartDateDate = new Date()
defaultStartDateDate.setHours(0)
defaultStartDateDate.setMinutes(0)
defaultStartDateDate.setSeconds(0)
const defaultStartDate = defaultStartDateDate.getTime()

// Default end date
const defaultEndDateDate = new Date()
defaultEndDateDate.setDate(new Date().getDate() + 366)
defaultEndDateDate.setHours(0)
defaultEndDateDate.setMinutes(0)
defaultEndDateDate.setSeconds(0)
const defaultEndDate = defaultEndDateDate.getTime()

class Layers extends PureComponent {
    static propTypes = {
        editFormValue: PropTypes.func.isRequired,
        form: PropTypes.shape(playlistsFormProps).isRequired,
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool.isRequired,
        updatePlaylist: PropTypes.func.isRequired,
        playlist: PropTypes.shape(playlistsFormProps),
        editForm: PropTypes.func.isRequired,
        selectedChainId: PropTypes.number,
    }

    static defaultProps = {
        isOpen: false,
        playlist: null,
    }

    constructor(props) {
        super(props)

        this.state = {
            formErrors: {
                name: null,
                date_start: null,
                date_end: null,
                slug: null,
            },
        }

        this.onChangeFormValue = this.onChangeFormValue.bind(this)
        this.onClickNullStartDate = this.onClickNullStartDate.bind(this)
        this.onClickNullEndDate = this.onClickNullEndDate.bind(this)
        this.onClickRemoveStartDate = this.onClickRemoveStartDate.bind(this)
        this.onClickRemoveEndDate = this.onClickRemoveEndDate.bind(this)
        this.onSubmit = this.onSubmit.bind(this)

        const { playlist } = props

        if (playlist) {
            this.initForm()
        }
    }

    componentDidUpdate(prevProps) {
        const { playlist, isOpen } = this.props
        const { isOpen: prevIsOpen } = prevProps

        if (playlist && isOpen && isOpen !== prevIsOpen) {
            this.initForm()
        }
    }

    initForm = () => {
        const { playlist, editForm } = this.props

        if (!playlist) {
            return
        }

        const { date_end, date_start } = playlist
        const form = Object.assign({}, playlist)
        form.date_end = date_end ? new Date(date_end * 1000).getTime() : null
        form.date_start = date_start ? new Date(date_start * 1000).getTime() : null

        editForm('editPlaylists', form)
    }

    onChangeFormValue({ target: { name, value } }) {
        const { editFormValue } = this.props
        editFormValue('editPlaylists', { name, value })
    }

    onClickNullStartDate(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        this.onChangeFormValue({
            target: { name: 'date_start', value: defaultStartDate },
        })
    }

    onClickNullEndDate(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        this.onChangeFormValue({
            target: { name: 'date_end', value: defaultEndDate },
        })
    }

    onClickRemoveStartDate(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        this.onChangeFormValue({
            target: { name: 'date_start', value: null },
        })
    }

    onClickRemoveEndDate(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        this.onChangeFormValue({
            target: { name: 'date_end', value: null },
        })
    }

    onChangeChainId = (chainValue) => {
        const { editFormValue } = this.props;
        editFormValue('editChain', { name: 'chain_id', value: chainValue });
    }

    async onSubmit(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        if (!this.validate()) {
            return
        }

        const { form, updatePlaylist, editForm, playlist } = this.props
        const response = await updatePlaylist(form.id, form)
        if (response.type === 'UPDATE_PLAYLIST##SUCCESS') {
            const { date_end, date_start } = response.payload
            const newForm = Object.assign({}, response.payload)
            newForm.date_end = date_end ? new Date(date_end * 1000).getTime() : null
            newForm.date_start = date_start ? new Date(date_start * 1000).getTime() : null
            editForm('editPlaylists', newForm)
        } else {
            const { date_end, date_start } = playlist
            const newForm = Object.assign({}, playlist)
            newForm.date_end = date_end ? new Date(date_end * 1000).getTime() : null
            newForm.date_start = date_start ? new Date(date_start * 1000).getTime() : null
            editForm('editPlaylists', newForm)
        }
    }

    buildOnchangeObject() {
        return {
            name: this.onChangeFormValue,
            date_start: (value) => this.onChangeFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangeFormValue({ target: { name: 'date_end', value } }),
            slug: this.onChangeFormValue,
            chain_id: this.onChangeChainId
        }
    }

    /**
     * Form Validation
     */
    validate() {
        const { form } = this.props
        const formErrors = validate(form)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    render() {
        const { form, isOpen, isWorking, selectedChainId } = this.props
        const { formErrors } = this.state

        return (
            <PlaylistsFormExtra
                errors={formErrors}
                isOpen={isOpen}
                isWorking={isWorking}
                onChangeForm={this.buildOnchangeObject()}
                onClickSubmit={this.onSubmit}
                onClickNullStartDate={this.onClickNullStartDate}
                onClickNullEndDate={this.onClickNullEndDate}
                onClickRemoveStartDate={this.onClickRemoveStartDate}
                onClickRemoveEndDate={this.onClickRemoveEndDate}
                selectedChainId={selectedChainId}
                values={form}
            />
        )
    }
}

const mapStateToProps = ({
    content: {
        isWorking: { playlists: isWorking },
        layers: data,
        form: { editPlaylists: form },
    },
}) => ({
    data,
    form,
    isWorking,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            notify: notifyAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(Layers)
